"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var track_1 = require("../track");
var ManifestDataSource = /** @class */ (function () {
    /**
     * @param manifest Manifest object or path to remote manifest
     */
    function ManifestDataSource(manifest) {
        var _this = this;
        this.manifest = manifest;
        this.pathRoot = '';
        this.manifestPromise = new Promise(function (resolve, reject) {
            // if there's no manifest then return an empty manifest
            if (_this.manifest == null) {
                return resolve({
                    contigs: [],
                });
            }
            else if (typeof manifest === 'string' || (manifest instanceof String)) {
                var request_1 = new XMLHttpRequest();
                request_1.addEventListener('loadend', function (e) {
                    // assume success if in 2xx range
                    if (request_1.status >= 200 && request_1.status < 300) {
                        try {
                            var manifest_1 = JSON.parse(request_1.responseText);
                            resolve(manifest_1);
                        }
                        catch (e) {
                            reject("Error parsing manifest: " + e);
                        }
                    }
                    else {
                        reject("Could not load manifest: (" + request_1.status + ") " + request_1.statusText);
                    }
                });
                request_1.open('GET', _this.manifest);
                request_1.send();
            }
            else {
                return resolve(manifest);
            }
        });
    }
    ManifestDataSource.prototype.getContigs = function () {
        return this.manifestPromise.then(function (manifest) { return manifest.contigs; });
    };
    ManifestDataSource.prototype.loadACGTSequence = function (contig, startBaseIndex, span, lodLevel) {
        var path = this.pathRoot + "/"; // @! need to find path from manifest
        return track_1.SequenceTileLoader.loadACGTSequenceFromPath(path, contig, startBaseIndex, span, lodLevel);
        ;
    };
    ManifestDataSource.prototype.loadAnnotations = function (contig, startBaseIndex, span, macro) {
        var path = this.pathRoot + "/"; // @! need to find path from manifest
        return track_1.AnnotationTileLoader.loadValisGenesAnnotations(path, contig, startBaseIndex, span, macro);
    };
    return ManifestDataSource;
}());
exports.ManifestDataSource = ManifestDataSource;
exports.default = ManifestDataSource;
